/**
 * Created by Ning Jiang on 2021-05-05.
 */

import {SerialGameAssets} from "../SerialGameAssets";
import {Serial} from "../Serial";
import {Layers, SerialLayers} from "./SerialLayers";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {gsap} from "gsap";
import {XBetController} from "./XBetController";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";

export class SerialBackground extends PIXI.Container {

    private _backgroundMain:PIXI.Sprite;
    private _backgroundFS:PIXI.Sprite;
    private _backgroundFSSuper:PIXI.Sprite;
    private _backgroundEffectsContainer:PIXI.Container;
    private _spinSpine:PIXI.spine.Spine;

    private _reelBgEffectsContainer:PIXI.Container;
    private _reelBgEffects:PIXI.spine.Spine;
    private _reelBgTl:gsap.core.Timeline;

    private _screenDimmer:PIXI.Graphics;
    public screenTransition:TimelineSprite;

    private _currentMode:string;
    private _effectPlaying:boolean;

    constructor() {
        super();
        this.init();
    }

    private init() {
        this._screenDimmer = new PIXI.Graphics();
        this._screenDimmer.beginFill(0x000000, 1);
        this._screenDimmer.drawRect(-840, -840, 1680, 1680);
        this._screenDimmer.endFill();
        this._screenDimmer.alpha = 0;
        this._screenDimmer.position.set(360, 360);
        SerialLayers.getLayer(Layers.SCREENS)?.addChild(this._screenDimmer);

        this.screenTransition = new TimelineSprite(Serial.assetLoader.getTextures("screentransition/TransitionGlitch"));
        this.screenTransition.visible = false;
        this.screenTransition.anchor.set(0.5);
        this.screenTransition.scale.set(4);
        this.screenTransition.position.set(360, 360);

        //test
        const S2Spine = new PIXI.spine.Spine(Serial.assetLoader.getSpineAsset("S2"));
        S2Spine.autoUpdate = true;
        SerialLayers.getLayer(Layers.BACKGROUND)?.addChild(S2Spine);
        S2Spine.state.setAnimation(0, "Landing", false);
        const tl = gsap.timeline();
        tl.add(() => {
            S2Spine.parent.removeChild(S2Spine);
            S2Spine.destroy();
        }, S2Spine.spineData.findAnimation("Landing").duration);

        this._backgroundMain = new PIXI.Sprite(Serial.assetLoader.getTextures(SerialGameAssets.MAIN_GAME_BACKGROUND)[0]);
        this._backgroundMain.position.set(360, 360);
        this._backgroundMain.anchor.set(0.5, 0.5);
        const mainLogo = new PIXI.Sprite(ImgLoader.getImgTexture("logo_main"));
        mainLogo.anchor.set(0.5,0);
        mainLogo.position.set(0,-660);
        this._backgroundMain.addChild(mainLogo);

        SerialLayers.getLayer(Layers.BACKGROUND)?.addChild(this._backgroundMain);

        this._backgroundFS = new PIXI.Sprite(Serial.assetLoader.getTextures(SerialGameAssets.FS_GAME_BACKGROUND)[0]);
        this._backgroundFS.position.set(360, 360);
        this._backgroundFS.anchor.set(0.5, 0.5);
        this._backgroundFS.alpha = 0;
        const fsLogo = new PIXI.Sprite(ImgLoader.getImgTexture("logo_fs"));
        fsLogo.anchor.set(0.5,0);
        fsLogo.position.set(0,-660);
        this._backgroundFS.addChild(fsLogo);
        SerialLayers.getLayer(Layers.BACKGROUND)?.addChild(this._backgroundFS);

        this._backgroundFSSuper = new PIXI.Sprite(Serial.assetLoader.getTextures(SerialGameAssets.FS_SUPER_GAME_BACKGROUND)[0]);
        this._backgroundFSSuper.position.set(360, 360);
        this._backgroundFSSuper.anchor.set(0.5, 0.5);
        this._backgroundFSSuper.alpha = 0;
        const sfsLogo = new PIXI.Sprite(ImgLoader.getImgTexture("logo_sfs"));
        sfsLogo.anchor.set(0.5,0);
        sfsLogo.position.set(0,-660);
        this._backgroundFSSuper.addChild(sfsLogo);
        SerialLayers.getLayer(Layers.BACKGROUND)?.addChild(this._backgroundFSSuper);

        this._backgroundEffectsContainer = new PIXI.Container();
        this._backgroundEffectsContainer.position.set(360, 360);
        SerialLayers.getLayer(Layers.BACKGROUND)?.addChild(this._backgroundEffectsContainer);

        this._reelBgEffectsContainer = new PIXI.Container();
        this._reelBgEffectsContainer.position.set(360, 360);
        SerialLayers.getLayer(Layers.REEL_BACKGROUND)?.addChild(this._reelBgEffectsContainer);

        const reelBg = new PIXI.Sprite(Serial.assetLoader.getTextures("Reel_area_layout")[0]);
        reelBg.anchor.set(0.5, 1);
        reelBg.position.set(354, 730);
        SerialLayers.getLayer(Layers.REEL_BACKGROUND)?.addChild(reelBg);

        Serial.xBetController = new XBetController();
        SerialLayers.getLayer(Layers.REEL_BACKGROUND)?.addChild(Serial.xBetController);

        this.onOrientationChanged();
        this.onResize();
    }

    public onOrientationChanged() {
        // TODO: check restore, mode, orientation
    }

    public onResize() {
        // TODO: check restore, mode, orientation
    }

    public setMode(mode:string):void {
        this._currentMode = mode;
        Serial.ways.setMode(mode);
        if(mode.includes("SUPER")) {
            gsap.to(this._backgroundMain, {alpha : 0, duration : 0.8});
            gsap.to(this._backgroundFS, {alpha : 0, duration : 0.8});
            gsap.to(this._backgroundFSSuper, {alpha : 1, duration : 0.8});
        } else if(mode.includes(GameMode.FREESPIN)) {
            gsap.to(this._backgroundMain, {alpha : 0, duration : 0.8});
            gsap.to(this._backgroundFS, {alpha : 1, duration : 0.8});
            gsap.to(this._backgroundFSSuper, {alpha : 0, duration : 0.8});
        } else {
            gsap.to(this._backgroundMain, {alpha : 1, duration : 0.8});
            gsap.to(this._backgroundFS, {alpha : 0, duration : 0.8});
            gsap.to(this._backgroundFSSuper, {alpha : 0, duration : 0.8});
        }
    }

    public tweenDimmer(alpha:number, duration:number):gsap.core.Tween {
        return gsap.to(this._screenDimmer, {alpha : alpha, duration : duration});
    }

    public playSpinEffect():void {
        if(this._effectPlaying) {
            return;
        }

        if(!this._currentMode.includes("SUPER")) {
            return;
        }

        if(!this._spinSpine) {
            this._spinSpine = new PIXI.spine.Spine(Serial.assetLoader.getSpineAsset("bg"));
            this._spinSpine.autoUpdate = true;
            this._backgroundEffectsContainer.addChild(this._spinSpine);
            this._spinSpine.visible = false;
        }

        const tl = gsap.timeline();
        tl.add(() => {
            SerialLayers.getLayer(Layers.BACKGROUND)?.addChild(this._backgroundEffectsContainer);
            this._effectPlaying = true;
            this._spinSpine.visible = true;
            this._spinSpine.state.setAnimation(0, "sfs", false);
        });
        tl.add(() => {
            this._spinSpine.state.clearTrack(0);
            this._spinSpine.skeleton.setToSetupPose();
            this._spinSpine.state.setEmptyAnimation(0, 0);
            this._spinSpine.visible = false;
            this._effectPlaying = false;
        }, this._spinSpine.spineData.findAnimation("sfs").duration);
    }

    public playCutEffect():void {
        if(!this._reelBgEffects) {
            this._reelBgEffects = new PIXI.spine.Spine(Serial.assetLoader.getSpineAsset("bgCutting"));
            this._reelBgEffects.autoUpdate = true;
            this._reelBgEffectsContainer.addChild(this._reelBgEffects);
            this._reelBgEffects.visible = false;
        }

        if(this._reelBgTl && this._reelBgTl.isActive()) {
            this._reelBgTl.pause();
            this._reelBgTl.kill();
        }

        const effectName = `Cutting${this.getEffectName()}`;
        const tl = gsap.timeline();
        tl.add(() => {
            this._reelBgEffects.visible = true;
            this._reelBgEffects.state.setAnimation(0, effectName, false);
        });
        tl.add(() => {
            this._reelBgEffects.state.clearTrack(0);
            this._reelBgEffects.skeleton.setToSetupPose();
            this._reelBgEffects.state.setEmptyAnimation(0, 0);
            this._reelBgEffects.visible = false;
        }, this._reelBgEffects.spineData.findAnimation(effectName).duration);
    }

    private getEffectName():string {
        const mode = Serial.model.parsedGameData.mode;
        if(mode.includes("SUPER")) {
            return "SFS";
        }
        if(mode.includes("FREESPIN")) {
            return "FS";
        }

        return "Main";
    }
}